import { getLatestValue } from '../../../engine';
import { DateRange, DataTable, ValueAccessor } from '../../../models';
import { applyDateRangeWindow } from '../applyDateRangeWindow';
import { DateWindowFunction, DateWindowTypes } from '../core';

export interface DefinedStartDateWindow {
  readonly startDate: Date;
  type: DateWindowTypes.DEFINED_START;
}

export const definedStartDateWindow = (startDate: Date, accessor: ValueAccessor<Date>): DateWindowFunction => {
  return (table: DataTable) => {
    const endDate = getLatestValue(table)?.timestamp;
    if (!endDate) {
      return table;
    }
    const dateRange: DateRange = { first: startDate, last: endDate as Date };
    return applyDateRangeWindow(table, dateRange, accessor);
  };
};

export const createDefinedStartDateWindow = (startDate: Date): DefinedStartDateWindow => {
  return {
    type: DateWindowTypes.DEFINED_START,
    startDate,
  };
};
